import * as Yup from 'yup'
import i18n from '../../i18n'
import { VALIDATION, VALIDATION_MESSAGES } from '../../utils/translation-constants'

// eslint-disable-next-line import/prefer-default-export
export const GimacPaymentSchema = Yup.object().shape({
  pay: Yup.string().required('Please Select Merchant Payment '),
  wallet: Yup.string().required('Please Select Merchant Wallet '),
  amount: Yup.string().required(i18n.t(VALIDATION.AMOUNT)),
  mobileNo: Yup.string().required('Merchant Wallet No. is required'),
  remarks: Yup.string().required('Remarks is required'),
  customRemarks: Yup.string().when('remarks', {
    is: 'Custom',
    then: Yup.string().required(i18n.t(VALIDATION_MESSAGES.CUSTOM_REMARKS)),
    otherwise: Yup.string().optional(),
  }),
})

export const GimacTransferSchema = Yup.object().shape({
  wallet: Yup.string().required('Please Select Recipient Wallet '),
  pay: Yup.string().required('Please Select Recipient Payment '),
  mobileNo: Yup.string().required('Recipient Wallet No. is required'),
  amount: Yup.string().required(i18n.t(VALIDATION.AMOUNT)),
  remarks: Yup.string().required('Remarks is required'),
  customRemarks: Yup.string().when('remarks', {
    is: 'Custom',
    then: Yup.string().required(i18n.t(VALIDATION_MESSAGES.CUSTOM_REMARKS)),
    otherwise: Yup.string().optional(),
  }),
})

export const GimacAtmSchema = Yup.object().shape({
  mobileNo: Yup.string().required('Recipient Mobile No. is required'),
  amount: Yup.string().required(i18n.t(VALIDATION.AMOUNT)),
})
